import { render, staticRenderFns } from "./SharedStockItemPurchaseBySupplierTable.vue?vue&type=template&id=1e0de3c2"
import script from "./SharedStockItemPurchaseBySupplierTable.vue?vue&type=script&lang=ts"
export * from "./SharedStockItemPurchaseBySupplierTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports